import { Link } from "react-router-dom";
import FormBuilder from "../../common/components/formInputs/FormBuilder";
import { validatePassword } from "../../common/helpers/common";

function getFormInputs() {
  return [
    {
      type: "password",
      label: "Old Password",
      name: "oldPassword",
      placeholder: "Enter at least 8 characters",
      validation: {
        required: "Old Password is required",
        validate: validatePassword,
      },
    },
    {
      type: "password",
      label: "New Password",
      name: "newPassword",
      placeholder: "Enter at least 8 characters",
      validation: {
        required: "New Password is required",
        validate: validatePassword,
      },
    },
  ];
}

function ResetPasswordForm({ onSubmit, isSubmitting }) {
  return (
    <div className="bg-white text-gray-700 md:w-[450px]">
      <div className="font-bold my-2 mb-4 text-2xl font-bold">
        Reset Password
      </div>

      <FormBuilder
        formInputs={getFormInputs()}
        submitButtonLabel="Reset"
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
      />
    </div>
  );
}

export default ResetPasswordForm;
